import { atom, action } from "@reatom/framework";
import { withSearchParamsPersist } from "@reatom/url";

import { DEFAULT_PER_PAGE, MAX_PER_PAGE } from "../../constants/pagination";

export const cursorHistoryAtom = atom<string[]>([]);
export const nextCursorAtom = atom<string | undefined>(undefined);

export const cursorHistoryLengthAtom = atom<number>((ctx) => {
  return ctx.spy(cursorHistoryAtom).length;
});

export const currentPerPageAtom = atom<number>(DEFAULT_PER_PAGE).pipe(
  withSearchParamsPersist("perPage", {
    parse: (value) => parseInt(value || DEFAULT_PER_PAGE.toString(), 10),
    serialize: (value) => value.toString(),
  }),
);

export const addCursorToHistory = action((ctx, cursor: string) => {
  cursorHistoryAtom(ctx, (prev) => [...prev, cursor]);
});

export const resetCursorHistory = action((ctx) => {
  cursorHistoryAtom(ctx, []);
  nextCursorAtom(ctx, undefined);
});

export const currentCursorAtom = atom<string | undefined>((ctx) => {
  const history = ctx.spy(cursorHistoryAtom);
  const lastIndex = history.length - 1;
  return history[lastIndex];
}, "currentCursorAtom");

export const setCurrentPerPage = action((ctx, perPage: number) => {
  if (perPage <= 0 || perPage > MAX_PER_PAGE) {
    return;
  }
  currentPerPageAtom(ctx, perPage);
});
